<template>
  <div>
    <v-sheet class="page-card transparent-background-color">
      <v-card>
        <v-card-title class="mx-3">
          <span class="red--text d-inline-block text-truncate">
            {{ $t("Material.editDefaultUnits") }}
          </span>
          <span class="text-subtitle-1">
            （{{ $t("Material.Fields.hint") }}）
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-container>
            <v-row dense v-if="material.standard">
              <v-col
                v-for="(item, index) in material.standard.standard_details"
                :key="item.unit"
                cols="12"
                sm="6"
              >
                <StandardDetail
                  v-model="material.standard.standard_details[index]"
                  :default-unit="material.standard.default_standard_detail.unit"
                  :previewMode="previewMode"
                  editDefault
                  @make-defalut="changeDefaultUnit(item)"
                  @changeDefaultRate="changeDefaultRate(item)"
                />
              </v-col>
              <v-col cols="12" sm="6" v-if="!previewMode">
                <v-card>
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content class="text-subtitle-1">
                        <EditorUnit
                          v-model="addUnit"
                          :disabled-items="
                            material.standard &&
                            material.standard.standard_details
                              ? material.standard.standard_details.map(
                                  (standard_detail) => standard_detail.unit
                                )
                              : null
                          "
                        />
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- 模板设置 -->
      <v-card v-if="previewMode && edit_material_templates.length" class="my-5">
        <v-card-title>
          {{ $t("Material.Fields.template_setting") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-8 pb-12">
          <div class="mx-4 mb-4">
            <v-data-table
              :headers="materialTemplatesHeaders"
              :items="edit_material_templates"
              :loading="loading"
              multi-sort
              class="elevation-2 px-4 pt-1"
              :footer-props="$t('$config.footer-props')"
            >
              <template v-slot:item.new_unit="{ item }">
                <v-select
                  single-line
                  dense
                  hide-details
                  style="max-width: 60px; margin-right: auto; margin-left: auto"
                  :items="available_unit_select"
                  v-model="item.new_unit"
                />
              </template>
              <template v-slot:item.supply_price="{ item }">
                <span v-if="item.supply_price != ''">
                  {{ $t("Global.money") }}{{ item.supply_price | formatMoney }}
                </span>
              </template>
              <template v-slot:item.new_supply_price="{ item }">
                <v-text-field
                  v-model="item.new_supply_price"
                  single-line
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :prefix="$t('Global.money')"
                  style="max-width: 80px; margin-left: auto"
                />
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
      <!-- 库存商品设置 -->
      <v-card v-if="previewMode && edit_stock_materials.length" class="my-5">
        <v-card-title>
          {{ $t("Material.Fields.stock_materials_setting") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-8 pb-12">
          <div class="mx-4 mb-4">
            <v-data-table
              :headers="stockMaterialsHeaders"
              :items="edit_stock_materials"
              :loading="loading"
              multi-sort
              class="elevation-2 px-4 pt-1"
              :footer-props="$t('$config.footer-props')"
            >
              <template v-slot:item.new_unit="{ item }">
                <v-select
                  single-line
                  dense
                  hide-details
                  style="max-width: 60px; margin-right: auto; margin-left: auto"
                  :items="available_unit_select"
                  v-model="item.new_unit"
                />
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
      <!-- 供应商商品设置 -->
      <v-card v-if="previewMode && edit_supplier_materials.length" class="my-5">
        <v-card-title>
          {{ $t("Material.Fields.supplier_materials_setting") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-8 pb-12">
          <div class="mx-4 mb-4">
            <v-data-table
              :headers="supplierMaterialsHeaders"
              :items="edit_supplier_materials"
              :loading="loading"
              multi-sort
              class="elevation-2 px-4 pt-1"
              :footer-props="$t('$config.footer-props')"
            >
              <template v-slot:item.new_unit="{ item }">
                <v-select
                  single-line
                  dense
                  hide-details
                  style="max-width: 60px; margin-right: auto; margin-left: auto"
                  :items="available_unit_select"
                  v-model="item.new_unit"
                />
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
      <!-- 当前库存数量变化 -->
      <v-card v-if="previewMode && stock_materials.length" class="my-5">
        <v-card-title>
          {{ $t("Material.Fields.stock_materials_num") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-8 pb-12">
          <div class="mx-4 mb-4">
            <v-data-table
              :headers="stockMaterialsNumHeaders"
              :items="stock_materials"
              :loading="loading"
              multi-sort
              class="elevation-2 px-4 pt-1"
              :footer-props="$t('$config.footer-props')"
            >
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
      <!-- 当前库位数量变化 -->
      <v-card
        v-if="previewMode && stock_material_positions.length"
        class="my-5"
      >
        <v-card-title>
          {{ $t("Material.Fields.stock_materials_num") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-8 pb-12">
          <div class="mx-4 mb-4">
            <v-data-table
              :headers="stockMaterialPositionsNumHeaders"
              :items="stock_material_positions"
              :loading="loading"
              multi-sort
              class="elevation-2 px-4 pt-1"
              :footer-props="$t('$config.footer-props')"
            >
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                color="primary"
                block
                outlined
                @click="$emit('input', false)"
                >{{ $t("$vuetify.close") }}</v-btn
              >
            </v-col>
            <v-col cols="12" v-if="!previewMode">
              <v-btn color="accent" block @click="save()">{{
                $t("Material.previewSubmit")
              }}</v-btn>
            </v-col>
            <v-col cols="12" v-if="previewMode">
              <v-btn color="accent" block @click="save()">{{
                $t("CRUD.save")
              }}</v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Materials from "@/api/materials";
import StandardDetail from "./StandardDetail";
import EditorUnit from "./EditorUnit";

export default {
  name: "EditDefaultUnits",

  props: {
    value: Boolean,
    editMaterial: Object,
  },

  computed: {
    materialTemplatesHeaders() {
      return [
        {
          text: i18n.t("Material.templates.name"),
          align: "start",
          value: "template.template_name",
        },
        {
          text: i18n.t("Material.Fields.org_unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("Material.Fields.org_supply_price"),
          align: "start",
          value: "supply_price",
        },
        {
          text: i18n.t("Material.Fields.new_unit"),
          align: "center",
          value: "new_unit",
        },
        {
          text: i18n.t("Material.Fields.new_supply_price"),
          align: "start",
          value: "new_supply_price",
        },
      ];
    },
    stockMaterialsHeaders() {
      return [
        {
          text: i18n.t("Material.Fields.stock_name"),
          align: "start",
          value: "stock.name",
        },
        {
          text: i18n.t("Material.Fields.org_stock_unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("Material.Fields.new_stock_unit"),
          align: "center",
          value: "new_unit",
        },
      ];
    },
    supplierMaterialsHeaders() {
      return [
        {
          text: i18n.t("Material.Fields.supplier_name"),
          align: "start",
          value: "supplier.supplier_name",
        },
        {
          text: i18n.t("Material.templates.unit"),
          align: "center",
          value: "new_unit",
        },
      ];
    },
    stockMaterialsNumHeaders() {
      return [
        {
          text: i18n.t("Material.Fields.stock_name"),
          align: "start",
          value: "stock_name",
        },
        {
          text: i18n.t("Material.Fields.old_current_count"),
          align: "center",
          value: "old_current_count",
          sortable: false,
        },
        {
          text: i18n.t("Material.Fields.now_current_count"),
          align: "center",
          value: "now_current_count",
          sortable: false,
        },
      ];
    },
    stockMaterialPositionsNumHeaders() {
      return [
        {
          text: i18n.t("Material.Fields.position_name"),
          align: "start",
          value: "position_name",
        },
        {
          text: i18n.t("Material.Fields.old_current_count"),
          align: "center",
          value: "old_current_count",
        },
        {
          text: i18n.t("Material.Fields.now_current_count"),
          align: "center",
          value: "now_current_count",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    material: {},
    addUnit: null,
    previewMode: false,
    available_unit_select: {},
    edit_material_templates: [],
    edit_stock_materials: [],
    edit_supplier_materials: [],
    stock_materials: [],
    stock_material_positions: [],
  }),
  components: {
    StandardDetail,
    EditorUnit,
  },

  methods: {
    save() {
      this.$store.dispatch("fullscreenLoading");
      var data = {};
      var errorRate = null;
      this.material.standard.standard_details.forEach((detail) => {
        //换算比例小数超过两位不提交
        var res = detail.rate.toString().split(".");
        if (res[1]) {
          if (
            !(
              detail.default_flg == 0 &&
              detail.origin_default_flg == 1
            )
          ) {
            if (res[1].length > 2) {
              errorRate += 1;
            }
          }
        }

        if (
          detail.origin_default_flg != 1 &&
          detail.rate < 1
        ) {
          errorRate += 1;
        }
      });
      if (errorRate) {
        this.$snackbar.error(i18n.t("Material.errorRate"));
        this.$store.dispatch("fullscreenLoadingStop");
      } else {
        var standard_details = this.material.standard.standard_details.map(
          (detail) => {
            if (
              detail.default_flg == 0 &&
              detail.origin_default_flg == 1 &&
              detail.rate < 1
            ) {
              detail.status = 1; //原基准单位禁用
            }
            return {
              id: detail.id,
              default_flg: detail.default_flg,
              status: detail.status,
              unit: detail.unit,
              rate: detail.rate,
            };
          }
        );

        data = {
          material_id: this.material.id,
          submit_flg: this.previewMode ? 1 : 0, //提交预览为0，提交保存为1
          standard_details: standard_details,
        };
        if (this.previewMode && this.edit_material_templates.length) {
          var edit_material_templates = this.edit_material_templates.map(
            (template) => {
              return {
                id: template.id,
                unit: template.new_unit,
                supply_price: template.new_supply_price,
              };
            }
          );
          data = Object.assign({}, data, {
            edit_material_templates: edit_material_templates,
          });
        }
        if (this.previewMode && this.edit_stock_materials.length) {
          var edit_stock_materials = this.edit_stock_materials.map(
            (material) => {
              return { id: material.id, unit: material.new_unit };
            }
          );
          data = Object.assign({}, data, {
            edit_stock_materials: edit_stock_materials,
          });
        }
        if (this.previewMode && this.edit_supplier_materials.length) {
          var edit_supplier_materials = this.edit_supplier_materials.map(
            (material) => {
              return { id: material.id, unit: material.new_unit };
            }
          );
          data = Object.assign({}, data, {
            edit_supplier_materials: edit_supplier_materials,
          });
        }
        Materials.editDefaultUnitPreview(data)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                if (this.previewMode) {
                  this.previewMode = false;
                  this.$router.push("/materials");
                } else {
                  this.previewMode = true;
                  this.available_unit_select = Object.values(
                    response.data.available_unit_select
                  );
                  var new_unit = "";
                  this.material.standard.standard_details.forEach(
                    (standard) => {
                      if (standard.default_flg == 1) {
                        new_unit = standard.unit;
                      }
                    }
                  );
                  this.edit_material_templates =
                    response.data.edit_material_templates.map((template) => {
                      // 单位默认修改为新基准单位

                      return Object.assign({}, template, {
                        new_unit: new_unit,
                      });
                    });
                  this.edit_material_templates.unshift({
                    id: 0,
                    template: {
                      template_name: i18n.t(
                        "Material.Fields.default_template_name"
                      ),
                    },
                    unit: this.material
                      ? this.material.supply_standard_detail
                        ? this.material.supply_standard_detail.unit
                        : ""
                      : "",
                    supply_price: this.material.supply_price,
                    new_unit: new_unit,
                  });
                  this.edit_stock_materials =
                    response.data.edit_stock_materials.map((material) => {
                      return Object.assign({}, material, {
                        new_unit: new_unit,
                      });
                    });
                  this.edit_supplier_materials =
                    response.data.edit_supplier_materials.map((material) => {
                      return Object.assign({}, material, {
                        new_unit: new_unit,
                      });
                    });
                  this.stock_materials = response.data.stock_materials;
                  this.stock_material_positions =
                    response.data.stock_material_positions;
                }
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      }
    },
    changeDefaultUnit(defaultUnitItem) {
      if (defaultUnitItem.new) {
        //只有从大换小可以新增单位
        this.material.standard.standard_details.forEach((detail) => {
          if (detail.origin_default_flg == 1) {
            detail.edit = true; //判断原基准单位换算比例编辑框可不可编辑
          }
          detail.rate = detail.origin_rate;
        });
      } else {
        this.material.standard.standard_details.forEach((detail) => {
          if (detail.origin_default_flg == 1) {
            detail.edit = false;
          }
          detail.rate = detail.origin_rate / defaultUnitItem.origin_rate;
        });
      }
      this.material.standard.standard_details =
        this.material.standard.standard_details.map((item) => {
          if (item.unit == defaultUnitItem.unit) {
            item.default_flg = 1;
            item.rate = 1;
          } else {
            item.default_flg = 0;
          }

          return item;
        });
      this.material.standard.default_standard_detail = defaultUnitItem;
    },
    changeDefaultRate(item) {
      if (item.rate < 1) {
        // 提示不能输入小于1的数字
        this.$snackbar.error(i18n.t("Material.Fields.rate_hint"));
      } else if (item.origin_default_flg == 1) {
        var changeRate = "";
        this.material.standard.standard_details.forEach((item) => {
          if (item.origin_default_flg == 1) {
            changeRate = item.rate;
          }
        });

        this.material.standard.standard_details.map((item) => {
          if (item.origin_default_flg != 1 && item.default_flg != 1) {
            item.rate = item.origin_rate * changeRate;
          }
          return item;
        });
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.previewMode = false;
        }
      },
    },
    editMaterial: {
      handler() {
        this.editMaterial.standard.standard_details.map((item) => {
          // 标志最初的基准单位
          if (item.default_flg == 1) {
            item.origin_default_flg = 1;
          } else {
            item.origin_default_flg = 0;
          }
          item.origin_rate = item.rate; //保留原始换算比例
          return item;
        });

        this.material = this.editMaterial;
      },
    },
    addUnit: {
      handler() {
        if (this.addUnit && this.addUnit.name) {
          var newUnit = {
            default_flg: this.material.standard.standard_details.length == 0,
            unit: this.addUnit.name,
            rate: this.material.standard.standard_details.length == 0 ? 1 : "",
            new: this.material.standard.standard_details.length + 1,
            count_unit_flg: this.addUnit.count_unit_flg,
            status: 0, //启用
            origin_default_flg: 0,
            origin_rate: "",
          };
          this.material.standard.standard_details.push(newUnit);
          if (newUnit.default_flg) {
            this.material.supply_standard_detail = newUnit;
            this.material.standard.default_standard_detail = newUnit;
          }
          this.addUnit = { id: 0, name: "" }; //消除显示
        }
      },
    },
    material: {
      deep: true,
      handler() {
        // console.log(this.material);
      },
    },
  },
};
</script>